import React from "react";
import { Container } from "react-bootstrap";
import { BrowserRouter as Router } from "react-router-dom";
import { HelmetProvider, Helmet} from 'react-helmet-async';
import { AuthProvider } from "./contexts/AuthContext";
import MainLayout from "./Components/Layouts/MainLayout";
import AppRoutes from "./AppRoutes";
import 'react-toastify/dist/ReactToastify.css';


function App() {
  return (
    <Container fluid>
      <HelmetProvider>
        <Helmet>
          <link href="https://fonts.googleapis.com/css2?family=Outfit:wght@400;700&display=swap" rel="stylesheet" />
        </Helmet>
        <Router
          future={{
            v7_relativeSplatPath: true,
            v7_startTransition: true
          }}>
          <AuthProvider>
            <MainLayout>
              <AppRoutes />
            </MainLayout>
          </AuthProvider>
        </Router>
      </HelmetProvider>
    </Container>
  );
}

export default App;
